import classnames from 'classnames'

export default function FormField({ adornment, error, ...inputProps }) {
  return (
    <div className={classnames('inputContainer flex alignCenter', { error }, inputProps.className)}>
      <input {...inputProps} />
      {!!adornment && <div className='adornment'>{adornment}</div>}

      <style jsx>{`
        .inputContainer {
          position: relative;
          height: 4.2rem;
          border-radius: 2.1rem;
          background: #fff;

          input {
            width: 100%;
            height: 100%;
            padding: 0 1.9rem;
            border-radius: inherit;
            outline: none;
            background: transparent;
            border: 0.2rem solid var(--secondary-input-bg);
            font-size: 1.6rem;
            transition: border-color 0.2s;
            transform: translateZ(0);

            &:focus {
              border-color: var(--primary-color);
            }

            &::placeholder {
              color: var(--secondary-text-color);
            }
          }

          .adornment {
            position: absolute;
            top: 50%;
            right: 1.9rem;
            transform: translate(0, -50%);
          }

          &.error {
            input {
              border-color: var(--alert-color);
            }
          }
        }

        @media (max-width: 1024px) {
          .inputContainer {
            height: 3.5rem;
            border-radius: 1.8rem;

            input {
              font-size: 1.2rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
